<template>
    <div>
        <swb-query-sort-area v-if="!add" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>
        <div class="clearfix"><a v-if="add" class="swb-btn-link fr mt5" @click="selectAllServicer">设置默认服务商</a></div>
        <div>
            <el-card class="box-card mt10" v-for="(servcType,index) in servcTypeList">
                <div slot="header" class="clearfix">
                    <span class=" font18 font-gold">{{servcType.text}}</span>
                    <el-button v-if="add" style="float: right; padding: 3px 0" @click="selectServicer(servcType.value, servcType.text)" type="text">
                        <span>选择服务商</span>
                    </el-button>
                </div>
                <div class="text item">
                    <el-table :data="comnRepairServicerMap[servcType.value]" border style="width: 100%">
                        <el-table-column prop="servicerName" label="服务商"></el-table-column>
                        <el-table-column label="是否默认">
                            <template slot-scope="rows">
                                <span v-if="rows.row.defaulted" class="font-red">是</span>
                                <span v-else>否</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="!showServc" prop="servcTitle" label="服务"></el-table-column>
                        <el-table-column prop="memo" label="备注">
                            <template slot-scope="rows">
                                <el-input v-if="add" v-model="rows.row.memo" placeholder="请输入备注"></el-input>
                                <span v-else>{{rows.row.memo}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" v-if="add">
                            <template slot-scope="rows">
                                <a class="swb-btn-link" v-if="!rows.row.defaulted " @click="setDefaulted(rows.row.servicerId, servcType.value)">设置默认</a>
                                <a class="swb-btn-link" v-if="rows.row.ssuId == null" @click="setServc(rows.row.servicerId, servcType.value)">设置服务</a>
                                <a class="swb-btn-link" v-if="rows.row.ssuId != null" @click="deleteServc(rows.row.servicerId, servcType.value)">删除服务</a>
                                <a class="swb-btn-link" @click="deleteServicer(rows.row.servicerId, servcType.value)">删除</a>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-card>
        </div>
    </div>
</template>


<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../../src/app.conf'
    import { checkUserActionPerm } from '../index'

    import shopComnReqApi from '../../api/shopComnReq'

    import { openServicerSelectComnDlg } from '../servicer/selectDlg'
    import { openServcDlg } from '../servc/selectDlg'
    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "label": "服务商",
                "code": "servicerName",
                "basic": true,
                "valueType": "String"
            }, {
                "type": "Text",
                "label": "服务",
                "code": "servcTitle",
                "basic": true,
                "valueType": "String"
            }, {
                "type": "Text",
                "label": "备注",
                "code": "memo",
                "basic": true,
                "valueType": "String"
            }
        ],
        "sortFields": []
    };
    export default {
        name: 'swb-shop-comn-repair-servicer',
        desc: '设备服务商',
        props: ["repairId", "showRepair", "add", "servcCatId"],
        data: function () {
            return {
                servcTypeList: [],
                comnRepairServicerMap: {},
                //排序、搜索
                queryConfig: searchConfigData,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
            }
        },
        created: function () {
            this.servcTypeList = getEnumList('servcType') || [];
            if(this.servcCatId != null) {
                let filter = {
                    servcCatId: this.servcCatId
                };
                let theFilter = Utils.merge({}, filter);
                this.theCatId = theFilter.servcCatId;
            } else {
                this.theCatId = null;
            }
            if(!Utils.isNoB(this.repairId)) {
                this.getShopComnReqServicerListByRepairId();
            }
        },
        watch: {
            showRepair(newVal, oldVal){
                if(newVal != oldVal) {
                    //
                    this.comnRepairServicerMap = Utils.merge({});
                }
            },
            servcCatId(newVal, oldVal){
                if(newVal != oldVal) {
                    if(this.servcCatId != null) {
                        let filter = {
                            servcCatId: this.servcCatId
                        };
                        let theFilter = Utils.merge({}, filter);
                        this.theCatId = theFilter.servcCatId;
                    } else {
                        this.theCatId = null;
                    }
                }
            }
        },
        methods: {
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                //
                this.getShopComnReqServicerListByRepairId();
            },
            getShopComnReqServicerListByRepairId: function () {
                let self = this;
                let postData = {};
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                filterItems.repairId = self.repairId;
                postData.filterItems = filterItems;
                shopComnReqApi.getShopComnRepairServicerList(postData, function (result) {
                    if(result.type == "info") {
                        self.comnRepairServicerMap = result.data;
                    }
                })
            },

            selectServicer: function (servcType, servcTypeName) {
                let self = this;
                if(Utils.isFalse(self.showRepair)) {
                    MsgBox.warning("请选择常规服务信息");
                    return;
                }
                let comnRepairServicerMap = self.comnRepairServicerMap;
                let comnRepairServicerList = comnRepairServicerMap[servcType] || [];
                let defaulted = false;
                if(comnRepairServicerList.length > 0) {
                    comnRepairServicerList.forEach(function (item) {
                        if(Utils.isTrue(item.defaulted)) {
                            defaulted = true;
                        }
                    })
                }
                let servicerIds = comnRepairServicerList.pluck("servicerId") || [];
                let params = {
                    initCheckedIds: servicerIds,
                    multiSelectDisabled: true,
                    multiSelect: true,
                    showContract: true, // 合同
                    showOrder: true, // 订单
                    showAmbilateralBizRel: true, // 双方关联
                    showBizRel: true, // 备选
                    showAdverseBizRel: true, // 卖方关联，备选其他
                    showNoScoreBizRel: true, // 待入围
                    showShieldedBizRel: true, // 加黑
                };
                openServicerSelectComnDlg(self, params, function (result) {
                    let servicerList = result.checkedList;
                    servicerList.forEach(function (item) {
                        let comnRepairServicer = {};
                        comnRepairServicer.repairId = self.repairId;
                        comnRepairServicer.servicerId = item.id;
                        comnRepairServicer.servicerName = item.name;
                        comnRepairServicer.servcType = servcType;
                        comnRepairServicer.servcTypeName = servcTypeName;
                        comnRepairServicerList.push(comnRepairServicer);
                    });
                    if(Utils.isFalse(defaulted)) {
                        let comnRepairServicer = comnRepairServicerList[0];
                        comnRepairServicer.defaulted = true;
                    }
                    comnRepairServicerMap[servcType] = Utils.merge([], comnRepairServicerList);
                    self.comnRepairServicerMap = Utils.merge({}, comnRepairServicerMap);
                })
            },
            setDefaulted: function (servicerId, servcType) {
                let self = this;
                this.$confirm("确定该服务商设置为默认？", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let comnRepairServicerMap = self.comnRepairServicerMap;
                    let comnRepairServicerList = comnRepairServicerMap[servcType] || [];
                    comnRepairServicerList.forEach(function (item) {
                        if(item.servicerId == servicerId) {
                            item.defaulted = true;
                        } else {
                            item.defaulted = false;
                        }
                    });
                    comnRepairServicerMap[servcType] = Utils.merge([], comnRepairServicerList);
                    self.comnRepairServicerMap = Utils.merge({}, comnRepairServicerMap);
                }).catch(function () {
                });
            },
            deleteServicer: function (servicerId, servcType) {
                let self = this;
                this.$confirm("确定移除该服务商？", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let comnRepairServicerMap = self.comnRepairServicerMap;
                    let comnRepairServicerList = comnRepairServicerMap[servcType] || [];
                    let comnRepairServicer = comnRepairServicerList.find(function (item) {
                        return item.servicerId == servicerId;
                    });
                    comnRepairServicerList.remove(comnRepairServicer);
                    if(Utils.isTrue(comnRepairServicer.defaulted)) {
                        if(comnRepairServicerList.length > 0) {
                            comnRepairServicerList[0].defaulted = true;
                        }
                    }
                    comnRepairServicerMap[servcType] = Utils.merge([], comnRepairServicerList);
                    self.comnRepairServicerMap = Utils.merge({}, comnRepairServicerMap);
                }).catch(function () {
                });
            },
            setServc: function (servicerId, servcType) {
                let self = this;
                let comnRepairServicerMap = self.comnRepairServicerMap;
                let comnRepairServicerList = comnRepairServicerMap[servcType] || [];
                let filter = {
                    merchantId: servicerId,
                    merchantType: getEnumInfoWith('merchantType', 'name', 'Servicer').value,
                    checkBox: false,
                    type: servcType
                };
                openServcDlg(filter, function (msu) {
                    let comnRepairServicer = comnRepairServicerList.find(function (item) {
                        return item.servicerId == servicerId;
                    });
                    comnRepairServicer.ssuId = msu.ssuId;
                    comnRepairServicer.servcCatId = msu.catId;
                    comnRepairServicer.servcId = msu.servcId;
                    comnRepairServicer.servcTitle = msu.title;
                    comnRepairServicerMap[servcType] = Utils.merge([], comnRepairServicerList);
                    self.comnRepairServicerMap = Utils.merge({}, comnRepairServicerMap);
                    if(self.theCatId == null) {
                        self.theCatId = msu.catId;
                    }
                })
            },
            deleteServc: function (servicerId, servcType) {
                let self = this;
                let comnRepairServicerMap = self.comnRepairServicerMap;
                let comnRepairServicerList = comnRepairServicerMap[servcType] || [];
                let comnRepairServicer = comnRepairServicerList.find(function (item) {
                    return item.servicerId == servicerId;
                });
                comnRepairServicer.ssuId = null;
                comnRepairServicer.servcId = null;
                comnRepairServicer.servcTitle = null;
                comnRepairServicer.servcCatId = null;
                comnRepairServicerMap[servcType] = Utils.merge([], comnRepairServicerList);
                self.comnRepairServicerMap = Utils.merge({}, comnRepairServicerMap);
            },
            selectAllServicer: function () {
                let self = this;
                if(Utils.isFalse(self.showRepair)) {
                    MsgBox.warning("请选择设备信息");
                    return;
                }
                let params = {
                    multiSelectDisabled: true,
                    multiSelect: false,
                    showContract: true, // 合同
                    showOrder: true, // 订单
                    showAmbilateralBizRel: true, // 双方关联
                    showBizRel: true, // 备选
                    showAdverseBizRel: true, // 卖方关联，备选其他
                    showNoScoreBizRel: true, // 待入围
                    showShieldedBizRel: true, // 加黑
                };
                openServicerSelectComnDlg(self, params, function (result) {
                    let servicer = result.checkedList;
                    let servcTypeList = self.servcTypeList;
                    let comnRepairServicerMap = self.comnRepairServicerMap || {};
                    for(let i = 0; i < servcTypeList.length; i++) {
                        let servcType = servcTypeList[i];
                        let comnRepairServicerList = comnRepairServicerMap[servcType.value] || [];
                        let comnRepairServicer = null;
                        if(comnRepairServicerList.length > 0) {
                            comnRepairServicerList.forEach(function (item) {
                                if(item.servicerId == servicer.id) {
                                    item.defaulted = true;
                                } else {
                                    item.defaulted = false;
                                }
                            });
                            comnRepairServicer = comnRepairServicerList.find(function (item) {
                                if(item.servicerId == servicer.id) {
                                    return item;
                                }
                            })
                        }
                        if(Utils.isNoB(comnRepairServicer)) {
                            comnRepairServicer = {};
                            comnRepairServicer.servicerId = servicer.id;
                            comnRepairServicer.servicerName = servicer.name;
                            comnRepairServicer.servcType = servcType.value;
                            comnRepairServicer.servcTypeName = servcType.text;
                            comnRepairServicer.defaulted = true;
                            comnRepairServicerList.push(comnRepairServicer);
                        }
                        comnRepairServicerMap[servcType.value] = comnRepairServicerList;
                    }
                    self.comnRepairServicerMap = Utils.merge({}, comnRepairServicerMap);
                })

            },
            getDlgResult: function () {
                let self = this;
                let result = {
                    type: "info",
                };
                let shopComnRepairServicerList = [];
                let servcTypeList = self.servcTypeList;
                let comnRepairServicerMap = self.comnRepairServicerMap;
                for(let i = 0; i < servcTypeList.length; i++) {
                    let servcType = servcTypeList[i];
                    let comnRepairServicerList = comnRepairServicerMap[servcType.value] || [];
                    if(comnRepairServicerList.length > 0) {
                        shopComnRepairServicerList = shopComnRepairServicerList.concat(comnRepairServicerList);
                    }
                }
                ;
                result.type = "info";
                result.data = shopComnRepairServicerList;

                return result;
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/compo/shopComnReq/ShopComnRepairServicerList.vue